<hero-application-frame [app]="appName"></hero-application-frame>
